const environment = {
  seguridad: window.env.seguridad,
  catalogo: window.env.catalogo,
  operaciones: window.env.operaciones,
  google: window.env.google,
  facebook: window.env.facebook,
};

export default environment;
